import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "exponent-participation-request" as const;

export type ExponentParticipationRequestEventData = {
  eventId: string;
  structureId: string;
};
export type ExponentParticipationRequestEvent = AppEvent<
  typeof eventName,
  ExponentParticipationRequestEventData
>;

export const isExponentParticipationRequestEvent = (
  event: AnyAppEvent
): event is ExponentParticipationRequestEvent => event.name === eventName;

export { eventName as exponentParticipationRequest };
